import React from 'react';
import agent from '../../../../agent';
import SavedSearchPieChartWidget from './SavedSearchPieChartWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

class SavedSearchPieChartWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      search: {
        rows:[]
      },
      loaded:false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.runSearch(this.props.savedSearchId, this.props.bypassCache, this.props.nameColumn, this.props.valueColumn);
  }

  runSearch(savedSearchId, bypassCache, nameColumn, valueColumn) {
    agent.Search.executePieChartSearch(savedSearchId, bypassCache, nameColumn, valueColumn).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            search:res.data,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }

  render() {
    if(this.state.loaded) {
      return (
        <SavedSearchPieChartWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} search={this.state.search}/>
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }
  }
}

export default SavedSearchPieChartWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchPieChartWidget/SavedSearchPieChartWidgetContainer.js